import reduce from './reducers/index';
import * as Actions from './actions/actions';
import ResponseHandler from './message-handlers/response';
//@ts-ignore
import ReportingEventHelper from './reporting-event-helper';
//@ts-ignore
import watch from 'redux-watch';
import {waitForIvaFunction} from '../lib-alight-library/lib-alight-library';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import { UserDataPayload } from '../../types/user-data-payload';
import { traceLog } from '../../src/logging';

export default class InitializationDataHandler{
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;
    _initializationDataExtResponseHandler: ResponseHandler;
    _reportingEventHelper: ReportingEventHelper;
    _initializationPromises: any;

    constructor(settings: AlightCustomSettingsType){
        this._settings = settings;

        this._initializationDataExtResponseHandler = new ResponseHandler(settings);
        this._reportingEventHelper = new ReportingEventHelper(settings);

    }   //  end constructor

    initialize(store: Store<AlmeState>, initPromise: any): void{
        this._store = store;
        this.setupProductPayloadFunction();
        this._initializationPromises = initPromise;

        this._initializationDataExtResponseHandler.initialize(store);
        this._reportingEventHelper.initialize(store);


        this.setupWatcher();
    }   //  end initialize

    setupWatcher(): void{
        const minimizedStateLocation = `${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.IsMinimized}`;
        const launchWatcher = watch(this._store?.getState, minimizedStateLocation);
        this._store?.subscribe(launchWatcher((newVal: any, oldVal: any, objectPath: any) =>
        {
            if(!newVal)
            {
                // watcher reloads data for payload relaunch. Setup to make testing easier
                //@ts-ignore
                const persistentInitData = this._store?.getState().Window.initializationData;
                if (persistentInitData && persistentInitData.multiTenantId){
                    this.getInitData();
                }
            }
        }));
    }

    getReducer(): (state: {} | undefined, action: any) => {}{
        return reduce;
    }

    getResponseHandler(): ResponseHandler{
        return this._initializationDataExtResponseHandler;
    }

    getPromise(): void | Promise<void>{
        if (this.shouldAct()) {
            return this.getInitData();
        }

        return Promise.resolve();
    }

    getInitData(): void{
        waitForIvaFunction().then((result) =>{
            if(result == true){
                const initDataBaseLocation  = `${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.initializationData.Base}`;
                const initDataInput: any = {};
                if (window.enableIVAasService){
                    // Marking user loading complete occurs as part of the response for IVA as a Service Data
                    traceLog('NIT: Processing IVA as a Service Data', 'InitializationDataHandler');
                    this.processIvaAsAServiceInitData();
                }
                else{
                    initDataInput.checkForInitData = false;
                    this._store?.dispatch(Actions.saveInitData( {initDataBaseLocation, initDataInput} ));

                    //  ALIGHT-3865 - SPLIT THIS INTO TWO OPTIONS TO ACCOUNT FOR DIFFERENT
                    //  INITIALIZATION BEHAVIOR BETWEEN UPOINT AND VERINT TEST PAGES
                    //  JavaScript function that enables us to retrieve json payloads
                    if (window.enableIVA2Features){
                        traceLog('NIT: Processing Payload Data', 'InitializationDataHandler');
                        this.processPayloadData();
                    }   //  end if payload function exists
                    else{
                        return Promise.resolve();
                    }
                }
            }
        });
    }   //  end function getInitData


    processIvaAsAServiceInitData(): Promise<void>{
        const initDataBaseLocation  = `${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.initializationData.Base}`;
        const initDataInput: any = {};

        const initData = window.enableIVAasService();
        if (initData===undefined || initData === null){
            return Promise.resolve();
        }

        if (window.isWorkLifecycleQA){
            if(window.isWorkLifecycleQA() === true || window.isWorkLifecycleQA() == "true"){
                initData.isQAEnvironment = true;
            }else{initData.isQAEnvironment = false;}
        }
        else{
            initData.isQAEnvironment = false;
        }

        //  save multi-tenant ID and the UUID to the state
        if (initData.UUID)
            initDataInput.UUID = initData.UUID;
        if (initData.multiTenantId)
        {
            initData.multiTenantId = this.normalizeMultitenantId(initData.multiTenantId);
            initDataInput.multiTenantId = initData.multiTenantId;
        }
        if (initData.subjectType){
            initDataInput.subjectType = initData.subjectType;
        }
        if(initData.testCfg){
            initDataInput.testCfg = initData.testCfg;
        }
        if(initData.testCfgMap){
            initDataInput.testCfgMap = initData.testCfgMap;
        }

        if (initData.UUID && initData.multiTenantId)
            initDataInput.checkForInitData = true;

        if(initData.platformId) {
            initDataInput.platformId = initData.platformId;
        }

        if(initData.companyId) {
            initDataInput.companyId = initData.companyId;
        }

        initDataInput.enableSecureAwsConfig = initData.enableSecureAwsConfig ?? "false";

        initDataInput.userAuthenticated = (String(initData.userAuthenticated).toLowerCase() == "true");

        initDataInput.metadata = this.generateMetadata(initData);
        this._store?.dispatch(Actions.saveInitData( {initDataBaseLocation, initDataInput} ));

        //  check for userAuthenticated - on false, save initData instead of making api call
        if (initData.userAuthenticated === "false"){
            const windowBase = this._settings.stateLocations.Window.Base;
            const initDataBase = this._settings.stateLocations.Window.initializationData.Base;
            const receivedResponseBase = this._settings.stateLocations.Window.initializationData.receivedResponse.Base;
            const responseBase = this._settings.stateLocations.Window.initializationData.receivedResponse.response.Base;
            const initDataRetrieved = this._settings.stateLocations.Window.initializationData.receivedResponse.response.initDataRetrieved;

            const preAuthInitDataLocation = `${windowBase}.${initDataBase}.${receivedResponseBase}.${responseBase}.${initDataRetrieved}`;
            const preAuthInitDataInput = initData;
            const preAuthPayload = {
                preAuthInitDataLocation,
                preAuthInitDataInput
            };
            this._store?.dispatch(Actions.savePreAuthInitData(preAuthPayload));
        }

        traceLog(`NIT: Saved IVA as a Service Init Data: \n${JSON.stringify(initData)}`, 'InitializationDataHandler');
        if (window.deleteUUID) {
            window.deleteUUID();
        }
        return Promise.resolve();
    }

    processPayloadData(): Promise<void> | undefined{
        const windowBase = this._settings.stateLocations.Window.Base;
        const productStateLocation = this._settings.stateLocations.productInfo.productPayload;
        const UDPVarLocation  = `${this._settings.stateLocations.Window.UDPVars.Base}`;

        try{
            const payloadCatcher = this.setupPayloadCatcher();
            //  check if payload is there in general - this is for upoint test pages
            //@ts-ignore
            if (!this._store?.getState()[windowBase][productStateLocation]) {
                this.processPayloadAdvocacy(payloadCatcher);
                //  submit the payload to the store
                window.NITSubmitProductInfo(payloadCatcher);
            }   //  end if function exists and payload not already stored
            //@ts-ignore
            else if (!this._store?.getState()[windowBase][productStateLocation]["payloadSaved"]) {
                this.processPayloadAdvocacy(payloadCatcher);
                //  submit the payload to the store
                window.NITSubmitProductInfo(payloadCatcher);
            }
            else {
                //check if config data has changed
                //@ts-ignore
                const savedPayload = this._store?.getState()[windowBase][productStateLocation];
                if(this.comparePayloadsForChanges(savedPayload, payloadCatcher)){
                    this.processPayloadAdvocacy(payloadCatcher);
                    //  submit the payload to the store
                    window.NITSubmitProductInfo(payloadCatcher);
                }
                else{
                    return Promise.resolve();
                }

            }

            // TODO - Once Alight moves to new UUID Setup, this should ONLY occur when on MobileApp
            //  store UUID in separate location
            //  ALIGHT-3894 - checking for payloadCatcher because I only want to save this
            //                              the first time through, not on refresh
           
                
            //@ts-ignore
                if (!this._store?.getState()[windowBase][UDPVarLocation] && payloadCatcher) {
                    let UDPVarInput: any = {};
                    if (payloadCatcher && payloadCatcher["generalConfigData"]) {
                        UDPVarInput["UUID"] = payloadCatcher["generalConfigData"]["UUID"];
                    }

                    this._store?.dispatch(Actions.setUDPVars(`${windowBase}.${UDPVarLocation}`, UDPVarInput));
                }
          
        }
        catch(err){
            //Setup to handle cases where we have payload saved, but we're experiencing errors from Alight
            //@ts-ignore
            if (!this._store?.getState()[windowBase][productStateLocation]){
                throw err;
            }
            //@ts-ignore
            else if (!this._store.getState()[windowBase][productStateLocation]["payloadSaved"]){
                throw err;
            }
            else{
                window.console.warn("Error In EnableIva2Features function. Using old payload", err)
            }
        }
    }

    comparePayloadsForChanges(savedPayload: UserDataPayload, newPayload: UserDataPayload): boolean {
        if (JSON.stringify(savedPayload.generalConfigData) !== JSON.stringify(newPayload.generalConfigData) ||
            JSON.stringify(savedPayload.chatConfigData) != JSON.stringify(newPayload.chatConfigData) ||
            JSON.stringify(savedPayload.advocacyConfigData) != JSON.stringify(newPayload.advocacyConfigData) ||
            JSON.stringify(savedPayload.userProfileConfigData) != JSON.stringify(newPayload.userProfileConfigData) ||
            JSON.stringify(savedPayload.variableConfigData) != JSON.stringify(newPayload.variableConfigData)) {
            return true;
        }
        return false;
    }

    setupPayloadCatcher(): any{
        //  get the json payload from Alight
        let payloadCatcher = window.enableIVA2Features();
        //  trim white space from response codes in payload
        if (payloadCatcher.userProfileConfigData){
            payloadCatcher = this.trimResponseCodes(payloadCatcher);
        }
        // ALIGHT-3997
        if (payloadCatcher.generalConfigData){
            if(payloadCatcher.generalConfigData.multiTenantId){
                payloadCatcher.generalConfigData.multiTenantId = this.normalizeMultitenantId(payloadCatcher.generalConfigData.multiTenantId);
                if(payloadCatcher.generalConfigData.gcc === undefined){
                    payloadCatcher.generalConfigData.gcc = payloadCatcher.generalConfigData.multiTenantId
                }
            }
        }
        //  if the payload exists && if userAuthenticated == false, then turn off the NITReset function
        if (payloadCatcher.generalConfigData && !payloadCatcher.generalConfigData.userAuthenticated){
            const resetStateLocation = `${this._settings.stateLocations.GenerateNewSession.Base}.${this._settings.stateLocations.GenerateNewSession.resetEnabled}`;
            const userAuthenticatedValue = payloadCatcher.generalConfigData.userAuthenticated;
            this._store?.dispatch(Actions.setResetFunctionFlag(resetStateLocation, userAuthenticatedValue));
        }

        return payloadCatcher;
    }

    processPayloadAdvocacy(payload: UserDataPayload): void{
        const advocacyData = payload.advocacyConfigData;
        if(advocacyData != undefined && advocacyData != null)
        {
            const advocacyStateLocation = `${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.advocacyVariables.Base}.${this._settings.stateLocations.Window.advocacyVariables.advocacyConfigData}`;

            this._store?.dispatch(Actions.saveUserAdvocacy(advocacyStateLocation, advocacyData));
        }
    }


    setupProductPayloadFunction(): void{
        //  where to save the product info payload
        const stateLocation = `${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.productPayload.Base}`;

        //  Legacy, but being reused for new solution to send new payload
        window.NITSubmitProductInfo = (productPayload: any) => {
            traceLog(`NIT: In NITSubmitProductInfo Function \n\n${JSON.stringify(productPayload)}`, 'InitializationDataHandler')

            productPayload = productPayload || {};

            //@ts-ignore
            const accessKey = this._store?.getState()[this._settings.stateLocations.Conversation.Base][this._settings.stateLocations.Conversation.accessKey]

            if(accessKey !== null && accessKey !== undefined){
                productPayload.accessKey = accessKey;
            }

            const productSavedLocation = this._settings.stateLocations.Window.productPayload.payloadSaved;

            //  save product info payload when this function called
            this._store?.dispatch(Actions.saveProductPayload(productPayload, stateLocation, productSavedLocation, undefined));
            return Promise.resolve();
        };   //  end window.productInfoFunc

    }   //  end function setupProductPayload

    trimResponseCodes(payloadCatcher: any): any{

        const tempCatcher = payloadCatcher;

        //  AON-2512 - check to see if there are any blank Response Codes and remove any found
        const eupLength = tempCatcher.userProfileConfigData.length;
        for (let i = eupLength -1; i > -1; i--){
            if (tempCatcher.userProfileConfigData[i]["code"] === ""){
                tempCatcher.userProfileConfigData.splice(i, 1);
            }
        }

        return tempCatcher;
    }

    markUserInitializationComplete(): void{
        const completedLocation = `Window.initializationData.InitializeCompleted`;

        this._store?.dispatch(Actions.setUserInfoInitializeComplete(completedLocation));
    }

    normalizeMultitenantId(originalId: string): string{
        return originalId.split("_")[0];
    }


    shouldAct(): boolean
    {
        return true;
    }

    generateMetadata(obj: any): any{
        const metadata: any = {};
        const ignoredItems = [
            "customIVA", 
            "multiTenantId", 
            "UUID", 
            "platformId", 
            "testCfg", 
            "testCfgMap", 
            "subjectType", 
            "enableSecureAwsConfig",
            "userAuthenticated",
            "companyId",
        ];

        let property;
        for (property in obj){
            if(!ignoredItems.includes(property)){
                metadata[property] = obj[property];
            }
        }

        return metadata;
    }
}   //  end class InitializationDataHandler



// WEBPACK FOOTER //
// ./modules/initialization-data-handler/initialization-data-handler.ts